import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

const DEFAULT_SIZE = 20;

function createInteractor(repository: Repository): Interactor {
  return ({ project, page = 0, size = DEFAULT_SIZE }) =>
    present(
      repository
        .getDiscussions(project, page, size)
        .then((discussions) => ({ project, discussions, page, size }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
